/** Authenticated user profile from GET /api/auth/me. */
export interface AuthUser {
  id: number;
  username: string | null;
  email: string | null;
  permissions: string[];
  departments: string[];
  roles: string[];
}

/**
 * Permission codes that grant access to the Administration section.
 * Only true management/write permissions are listed here — view-only
 * permissions like admin.audit.view or admin.dashboard.update do NOT
 * unlock the admin nav so that department roles stay out of admin.
 */
export const ADMIN_GATE_PERMISSIONS: string[] = [
  'admin.users.read', 'admin.users.create', 'admin.users.update', 'admin.users.delete',
  'admin.access.read', 'admin.access.create', 'admin.access.update', 'admin.access.delete',
  'admin.settings.manage',
  'admin.email.manage', 'admin.emailtemplates.manage',
  'admin.lookups.manage', 'admin.customfields.manage', 'admin.holidays.manage',
  'admin.automation.manage',
  'admin.crm.scoring.manage', 'admin.crm.assignment.manage',
  'admin.dashboard.read',
];
